<template>
    <div class="row justify-content-center">
        <div class="col-md-12">
            <!-- Signup -->
            <div class="">

                <div class="px-3 pb-1">
                    <!-- Merchant Dropdown select -->
                    <div v-if="this.merchants.length > 1 || this.merchants[0]['merchants'].length > 1"
                         class="row my-3 my-md-4">
                        <div class="col-md-12 justify-content-end d-flex flex-row">

                            <div class="mr-2 bg-success d-flex justify-content-center align-items-center rounded-lg">
                                <p class="m-0 text-white d-flex align-items-center py-1 px-3 min-w-100"><i
                                    class="fas fa-map-marker-alt pr-1"></i> Standort:</p>
                            </div>

                            <signup-merchant :contact-id="this.contactId"
                                             :contact-type="this.contactType"
                                             :is-disabled="isDisabled"
                                             :wholesaler-merchant-data="this.merchants"
                                             class="w-100"
                                             @emitUpdateSelectedMerchant="updateSelectedMerchant"
                            ></signup-merchant>
                        </div>
                    </div>
                    <!-- End Merchant Dropdown select -->

                    <!-- Form visibility toggle Buttons -->
                    <div class="row my-3 my-md-4 mb-4">
                        <div class="col-md-6 py-2 py-md-0">
                            <button :class="this.visibilityMerchantForm ? 'shadow' : 'is-not-selected'"
                                    class="btn btn-success btn-block"
                                    type="button"
                                    @click="showMerchantForm"><i class="fal fa-address-card"></i> Neues
                                Training
                                für
                                Kaufleute!
                            </button>
                        </div>

                        <div class="col-md-6 py-2 py-md-0">
                            <button :class="this.visibilityEmployeeForm ? 'shadow' : 'is-not-selected'"
                                    class="btn btn-danger btn-block"
                                    type="button"
                                    @click="showEmployeeForm"><i class="fas fa-user-friends"></i> Neues
                                Training für
                                Mitarbeiter!
                            </button>
                        </div>
                    </div>
                    <!-- End Form visibility toggle Buttons -->

                    <!-- Loading Trainings -->
                    <loader v-if="!this.trainingDataLoaded"></loader>
                    <!-- End Loading Trainings -->

                    <!-- Show Signup Formular -->
                    <div v-else class="my-2 my-md-3">
                        <!-- Merchant Formular -->
                        <div>
                            <signup-form-builder v-if="this.visibilityMerchantForm"
                                                 :form-options="this.formMerchant"
                                                 :sendingEmail="this.sendingEmail"
                                                 headline="Trainings für Kaufleute"
                                                 @addTrainingData="addTraining"></signup-form-builder>
                        </div>
                        <!-- End Merchant Formular -->

                        <!-- Employee Formular -->
                        <div>
                            <signup-form-builder v-if="this.visibilityEmployeeForm"
                                                 :form-options="this.formEmployee"
                                                 :sendingEmail="this.sendingEmail"
                                                 headline="Trainings für Mitarbeiter"
                                                 @addTrainingData="addTraining">
                            </signup-form-builder>
                        </div>
                        <!-- End Employee Formular -->
                    </div>
                    <!-- End Signup Formular -->
                </div>
            </div>
            <!-- End Signup -->

            <!-- Results -->
            <div class="mt-3 mt-md-4 mt-lg-5 overflow-hidden">
                <section-headline msg="Trainings"></section-headline>

                <div class="px-3 py-1">
                    <div class="row mt-3 ">
                        <!-- Merchant List -->
                        <signup-list :filter-trainings-list="filterMerchantListTrainings"
                                     @deleteTraining="deleteTraining">
                            <template v-slot:headline>
                                <block-headline icon="fa-address-card" text="Kaufleute"></block-headline>
                            </template>
                            <template v-slot:empty-list-text>
                                <p class="list-group-item">Keine Trainings für Kaufleute.</p>
                            </template>
                        </signup-list>
                        <!-- End Merchant List -->

                        <!-- Employee List -->
                        <signup-list :filter-trainings-list="filterEmployeeListTrainings"
                                     class="border-left"
                                     @deleteTraining="deleteTraining">
                            <template v-slot:headline>
                                <block-headline icon="fa-user-friends" text="Mitarbeiter"></block-headline>

                            </template>
                            <template v-slot:empty-list-text>
                                <p class="list-group-item">Keine Trainings für Mitarbeiter.</p>
                            </template>
                        </signup-list>
                        <!-- End Employee List -->
                    </div>

                    <!-- Book Trainings Button -->
                    <div class="row mt-3 mb-3">
                        <div class="col-md-12 d-flex justify-content-end">
                            <button :disabled="this.listTrainings.length === 0 || this.sendingEmail"
                                    class="btn btn-success d-flex align-items-center justify-content-center"
                                    @click="submitTrainings">
                                <i v-if="!this.sendingEmail" class="fas fa-plus mr-1"></i>
                                <i v-if="this.sendingEmail" class="fa fa-spinner fa-spin fa-fw mr-1"></i> Trainings
                                Buchen
                            </button>
                        </div>
                    </div>
                    <!-- End Book Trainings Button -->
                </div>
            </div>
            <!-- End Results -->
        </div>
    </div>
</template>

<style scoped>
.is-not-selected {
    opacity: 0.5;
}
#form-logo {
    height: 60px;
    padding-top: 5px;
    padding-bottom: 5px;
}

@media (min-width: 768px) {
    #form-logo {
        height: 70px;
        padding-top: 5px;
        padding-bottom: 5px;
    }
}

@media (max-width: 768px) {
    .border-left {
        border: none !important;
    }
}
</style>

<script>

import SignupList from './SignupList';
import SignupFormBuilder from './SignupFormBuilder';
import SignupMerchant from './SignupMerchant';

export default {
    name: 'Signup',

    components: {
        SignupList,
        SignupFormBuilder,
        SignupMerchant,
    },

    props: {
        contactId: null,
        contactType: null,
        ParentMerchantId: null,
        typeMerchant: {
            type: String,
        },
        typeWholesaler: {
            type: String,
        },
        typeAdmin: {
            type: String,
        },
        merchants: {
            type: Array,
        },
    },

    data: function() {
        return {
            visibilityMerchantForm: true,
            visibilityEmployeeForm: false,
            submittedForm: null,
            sendingEmail: false,

            listTrainings: [],

            formMerchant: {
                'case': 'merchant',
                'trainings': [],
            },
            formEmployee: {
                'case': 'employee',
                'trainings': [],
            },
            merchantDataLoaded: false,
            trainingDataLoaded: false,
            merchantId: this.ParentMerchantId,
            wholesalerMerchantData: null,
        };
    },

    created() {
        //get all trainings
        axios.get('/api/campus/trainings').then((response) => {
            for (let i = 0; i < response.data.length; i++) {
                if (response.data[i].type === 'employee') {
                    this.formEmployee.trainings.push(response.data[i]);
                } else {
                    this.formMerchant.trainings.push(response.data[i]);
                }
            }

            this.trainingDataLoaded = true;
        }).catch((errors) => {
            this.$swal({
                position: 'center',
                icon: 'error',
                title: 'Es ist ein Fehler aufgetreten',
                showConfirmButton: false,
                timer: 5000,
            });
            this.form.trainingsOptions = [
                {
                    name: 'Es sind keine Trainings vorhanden!',
                },
            ];
        });
    },

    methods: {
        showMerchantForm: function() {
            this.visibilityMerchantForm = true;
            this.visibilityEmployeeForm = false;
        },

        showEmployeeForm: function() {
            this.visibilityEmployeeForm = true;
            this.visibilityMerchantForm = false;
        },
        addTraining: function(value) {
            value.forEach(item => this.listTrainings.push(item));
        },

        submitTrainings() {
            this.sendingEmail = true;
            axios.post('/api/campus/submit-trainings', {
                'merchantId': this.merchantId,
                'trainings': this.listTrainings,
            }).then((response) => {
                this.$swal({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 5000,
                });
                this.listTrainings = [];
                this.visibilityEmployeeForm = false;
                this.visibilityMerchantForm = true;
                this.sendingEmail = false;
            }).catch((errors) => {
                this.$swal({
                    position: 'center',
                    icon: 'error',
                    title: errors.response.data.message,
                    showConfirmButton: false,
                    timer: 5000,
                });
                this.sendingEmail = false;
            });
        },

        deleteTraining(id) {
            this.listTrainings.forEach((element, index) => {
                if (element.unique_id === id) {
                    this.listTrainings.splice(index, 1);
                }
            });
        },
        updateSelectedMerchant(merchant) {
            this.merchantId = merchant.id;
        },
    },

    computed: {
        toggleTrainingsList: function(someObject) {
            return Object.keys(someObject).length;
        },
        filterMerchantListTrainings() {
            return this.listTrainings.filter((item) => {
                return item.type === 'merchant';
            });
        },
        filterEmployeeListTrainings() {
            return this.listTrainings.filter(function(item) {
                return item.type === 'employee';
            });
        },
        isDisabled() {
            return this.listTrainings.length > 0;
        },
    },
};
</script>
